import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../../services/data/data.service';
import { ConfigService } from '../../services/config/config.service';
import { CommsService } from '../../services/comms/comms.service';
import { ContractorService } from '../../services/contractor/contractor.service';
import { DisplayService } from '../../services/display/display.service';
import { HelpService } from '../../services/help/help.service';
import { TimesheetService } from '../../services/timesheet/timesheet.service';
import { SmartContractService } from '../../services/smart-contract/smart-contract.service';
import { NoteService } from '../../services/note/note.service';
import { TabService } from '../../services/tab/tab.service';
import { UserService } from '../../services/user/user.service';

@Component({
	selector: 'pcm-page-contractors',
	templateUrl: './page-contractors.component.html',
	styleUrls: ['./page-contractors.component.scss']
})
export class PageContractorsComponent implements OnInit, OnDestroy {

	@ViewChild('modalForm') modalForm;
	@ViewChild('modalForm') removeTRAModal;

	title = 'Contractor Records';
	dataObj = this.configService.contractorDataObj;
	scDataObj = this.configService.contractorSCDataObj;
	activeModal = '';
	pending = '';
	selectionType = 'checkbox';

	actions = [];
	exportAction = [];
	archiveActions = [];
	cancellActions = [];
	anyActions = [];
	showExportModal = false;
	showRemoveTRAModal = false;
	columnsConfigs = [];
	currentEvent = '';

	jrSteps = [];
	jrStepIDs = [];

	initTab = '';

	userSettingsListener;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		public configService: ConfigService,
		private commsService: CommsService,
		private dataService: DataService,
		public contractorService: ContractorService,
		private displayService: DisplayService,
		public helpService: HelpService,
		public timesheetService: TimesheetService,
		private smartContractService: SmartContractService,
		private noteService: NoteService,
		private tabService: TabService,
		public userService: UserService
	) {
		this.helpService.contractors.forEach(step => {
			this.jrSteps.push(step);
			this.jrStepIDs.push(step.id);
		});
	}

	ngOnInit() {
		this.columnsConfigs = this.configService.getTableFields(this.dataObj, false);
		this.actions = this.configService.getActions(this.dataObj);
		this.exportAction = [];
		this.exportAction.push(this.configService.getExportAction());
		if (this.actions.length === 0) {
			this.actions = this.exportAction;
		}
		this.archiveActions = this.configService.getActions('archivedcontractor');
		this.cancellActions = this.configService.getActions('cancelledcontractor');
		this.anyActions = this.configService.getActions('anycontractor');
		this.timesheetService.loadQuantityTypes();

		this.route.params.subscribe(params => {
			this.initTab = params['initTab'];
			this.tabService.loadTab(this.contractorService.tabsData.listTabs, this.contractorService, this.initTab);
		});

		this.userSettingsListener = this.dataService.userSettingsListener().subscribe((event) => {
			console.log('USER SETTINGS LISTENER');
			this.tabService.loadTab(this.contractorService.tabsData.listTabs, this.contractorService, this.initTab);
		});
	}

	ngOnDestroy() {
		this.userSettingsListener.unsubscribe();
	}

	allowAction = () => {
		return this.dataService.selectedTableRows[0] !== undefined;
	}

	takeAction(event) {
		console.log('TAKE ACTION', event);
		this.currentEvent = event.action.prop;
		if (this.currentEvent === 'exporttocsv') {
			this.showExportModal = true;
		} else if (this.currentEvent === 'contractorremovetra') {
			this.showRemoveTRAModal = true;
		} else if (this.currentEvent === 'contractorrestore') {
			this.restoreContractors();
			this.contractorService.partialSuccessTitle = 'Contractors Restore Error(s)';
			this.contractorService.errorMsg = 'Some of the contractors failed restoring. See the table below for details.';
			this.contractorService.successMsg = 'The following contractors were restored successfully.';
		} else if (this.currentEvent === 'contractorarchive') {
			this.archiveContractors();
			this.contractorService.partialSuccessTitle = 'Contractors Move to Inactive Error(s)';
			this.contractorService.errorMsg = 'Some of the contractors failed moving to inactive tab. See the table below for details.';
			this.contractorService.successMsg = 'The following contractors were moved to inactive tab successfully.';
		} else {
			this.modalForm.showModal(event.action, this.scDataObj, this.dataService.selectedTableRows);
		}
	}

	modalSubmit(event) {
		console.log('MODAL SUBMIT', event);
		this.smartContractService.submitSmartContract(event.data, event.prop, this);
		this.currentEvent = event.prop;
		const delay = setTimeout(() => {
			this.modalForm.formCancel();
		}, 1000);
	}

	successCall() {
		this.dataService.clearSelectedTableRows();
		this.dataService.broadcastNotifications(this.dataObj);
		if (this.currentEvent === 'contractorassigntra') {
			setTimeout(() => {
				this.contractorService.loadContractorsForTab(this.contractorService.getActiveTab(this.contractorService.tabsData.listTabs));
			}, 1000);
		}
		this.currentEvent = '';
	}

	errorCall(err) {
		if (this.currentEvent === 'contractorarchive' || this.currentEvent === 'contractorrestore' || this.currentEvent === 'hoursrestriction') {
			this.contractorService.handlePartialSuccess(err);
		} else {
			this.noteService.displayError('Failed to process the selected contractors');
		}
	}

	partialCall(res) {
		console.log('BULK PARTIAL SUCCESS');
		if (this.currentEvent === 'contractorarchive' || this.currentEvent === 'contractorrestore') {
			this.contractorService.handlePartialSuccess(res);
		} else {
			this.noteService.displayError('Failed to process some or all the selected purchase orders');
		}
	}

	closeExportModal() {
		this.showExportModal = false;
	}

	exportToCSV(event) {
		this.commsService.exportToCSV(event.data, this.configService.getTableFields(this.dataObj, false), this.dataService.selectedTableRows);
		const self = this;
		const delay = setTimeout(function () {
			self.closeExportModal();
		}, 1000);
	}

	restoreContractors() {
		const cons = [];
		this.dataService.selectedTableRows.forEach((row) => {
			const con = {
				ponumber: row.ponumber,
				supplierid: row.supplierid,
				uuid: row.uuid
			};
			cons.push(con);
		});

		console.log('active contractors', cons);
		this.smartContractService.submitSmartContract(cons, 'contractorrestore', this);
	}

	archiveContractors() {
		const cons = [];
		this.dataService.selectedTableRows.forEach((row) => {
			const con = {
				ponumber: row.ponumber,
				supplierid: row.supplierid,
				uuid: row.uuid
			};
			cons.push(con);
		});

		console.log('active contractors', cons);
		this.smartContractService.submitSmartContract(cons, 'contractorarchive', this);
	}

	removeTRA() {
		console.log('Remove TRA');
		const data = {
			contractors: this.dataService.selectedTableRows,
			acltra: '',
			acl: {
				tra: {
					participants: []
				}
			}
		};
		const self = this;
		this.cancelRemoveTRAModal();
		this.displayService.startLoading();
		this.commsService.sendContractorDelegation(data).subscribe((res) => {
			console.log('ARCHIVE CONTRACTORS RES: ', res);
			self.noteService.displaySuccess('The Delegated Time Verifiers have been removed successfully.');
			const delay = setTimeout(function () {
				self.dataService.clearSelectedTableRows();
				self.contractorService.loadContractorsForTab(self.contractorService.getActiveTab(self.contractorService.tabsData.listTabs));
				// console.log('ACTION POST SUCCESS', self.dataService.selectedTableRows);
				self.displayService.endLoading();
			}, 1000);
		}, (err) => {
			self.commsService.handleAPIError('Remove DTV', err);
			const delay = setTimeout(function () {
				self.contractorService.loadContractorsForTab(self.contractorService.getActiveTab(self.contractorService.tabsData.listTabs));
				// console.log('ACTION POST SUCCESS', self.dataService.selectedTableRows);
				self.displayService.endLoading();
			}, 1000);
		});
	}

	cancelRemoveTRAModal() {
		this.showRemoveTRAModal = false;
	}

	onShowContractorSubmission() {
		this.contractorService.showContractorSubmissionModal = true;
		this.contractorService.resetUploadContractors();
	}
}
